<div class="ng-wrapper">
    <div class="ng-filter-item all-filters" (click)="showFilters()">
        <img class="ng-icon" src="/x-assets/img/icons/icon-filters.svg" alt=""/>
    </div>

    <div class="filter-pills-scroll">
        @for (filter of visibleFilters; track filter.filterKey) {
            <app-filter-pill [filterType]="filter.filterKey"
                             [filterName]="filter.name" [filter]="filter"
                             [appliedFilter]="getAppliedFilter(filter.filterKey)"
                             [appliedLabel]="filter.filterKey === 'stopovers' ? stopoversLabel : ''"
                             (openSheet)="onOpenSheet($event)"
                             (resetFilter)="onResetFilter($event)"/>
        }
    </div>
</div>

<app-filter-sheet [filter]="activeFilter"
                  [filterGroup]="activeFilterGroup"
                  [filters]="filters"
                  [appliedFilters]="appliedFilters"
                  [appliedFilter]="activeFilter ? getAppliedFilter(activeFilter.filterKey) : null"
                  (applyFilter)="onApplyFilter($event)"
                  (applyFilterGroup)="onApplyFilterGroup($event)"
                  (resetFilter)="onResetFilter($event)"
                  (resetFilterGroup)="onResetFilterGroup($event)"></app-filter-sheet>
